import React, { useState } from "react";
import {
  CogIcon,
  SupportIcon,
  UserCircleIcon,
} from "@heroicons/react/solid";
import {
  Nav,
  Image,
  Navbar,
  Dropdown,
  Container,
  OverlayTrigger,
  Tooltip,
  Card,
} from "react-bootstrap";

import { userNotifications } from "data/notifications";
import Profile3 from "assets/img/team/profile-picture-3.jpg";
import { MdEmail } from "react-icons/md";
import { Routes } from "routes";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router-dom";
import { BiLogOutCircle } from "react-icons/bi";
import WhatsappRegistrationModal from "pages/embedded/WhatsappRegistrationModal";
import WhatsappMigrationModal from "pages/embedded/WhatsappMigrationModal";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoChevronBackOutline } from "react-icons/io5";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);
export default ({ contentName, backPath, isCreate }) => {
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userID = userObject.id;

  const { id } = useParams();

  const showBack = backPath;

  const [notifications, setNotifications] = useState(userNotifications);
  const allNotificationsRead = notifications.reduce(
    (acc, notif) => acc && notif.read,
    true
  );
  const bellIconClasses = !allNotificationsRead ? "unread" : "";
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showModalMigration, setShowModalMigration] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const handleShowMigration = () => setShowModalMigration(true);
  const handleCloseMigration = () => setShowModalMigration(false);

  // const toggleContracted = () => props.toggleContracted && props.toggleContracted();

  const Logout = async () => {
    const textMessage = "Are you sure you want to log out?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm Exit",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      history.push(Routes.Presentation.path);
    }
  };

  const goBack = () => {
    if (!!backPath) {
      history.push(backPath);
    }
  };

  const getHeadingText = (isCreate, id, contentName) => {
    if (isCreate === "edit" || isCreate === "create") {
      if (id) {
        return `Edit ${contentName}`
      } else {
        return `Create ${contentName.replace(/management/i, "")}`
      }
    }
    return contentName;
  };

  // const markNotificationsAsRead = () => {
  //   setTimeout(() => {
  //     setNotifications(notifications.map((n) => ({ ...n, read: true })));
  //   }, 400);
  // };
  // const Notification = (props) => {
  //   const { link, sender, image, time, message, read = false } = props;
  //   const readClassName = read ? "" : "text-danger";
  //   const receiveTime = moment(time).fromNow();

  //   return (
  //     <ListGroup.Item
  //       action
  //       href={link}
  //       className="list-group-item-action border-bottom"
  //     >
  //       <Row className="align-items-center">
  //         <Col xs="auto">
  //           <Image src={image} className="avatar-md rounded" />
  //         </Col>
  //         <Col className="ps-0 ms-2">
  //           <div className="d-flex justify-content-between align-items-center">
  //             <div>
  //               <h4 className="h6 mb-0 text-small">{sender}</h4>
  //             </div>
  //             <div className="text-end">
  //               <small className={readClassName}>{receiveTime}</small>
  //             </div>
  //           </div>
  //           <p className="font-small mt-1 mb-0">{message}</p>
  //         </Col>
  //       </Row>
  //     </ListGroup.Item>
  //   );
  // };

  return (
    <Navbar expand className="bg-white navbar-top navbar-dashboard p-3">
      <Container fluid className="px-2">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center gap-2">
            {showBack && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip className="m-0">Go Back</Tooltip>}
              >
                <Card.Link className="ms-2" onClick={goBack}>
                  <IoChevronBackOutline className="icon icon-xs" />
                </Card.Link>
              </OverlayTrigger>
            )}
            <h5 className="m-0"> {getHeadingText(isCreate, id, contentName)}</h5>
          </div>

          <Nav className="align-items-center">
            {/* <Form className="navbar-search form-inline">
              <Form.Group id="topbarSearch">
                <InputGroup className="input-group-merge search-bar">
                  <InputGroup.Text>
                    <SearchIcon className="icon icon-xs" />
                  </InputGroup.Text>
                  <Form.Control type="text" placeholder="Search" />
                </InputGroup>
              </Form.Group>
            </Form> */}

            {/* <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead}>
              <Dropdown.Toggle
                as={Nav.Link}
                className={`text-dark notification-bell ${bellIconClasses}`}
              >
                <BellIcon className="icon icon-sm bell-shake text-gray-900" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-lg dropdown-menu-center mt-2 py-0">
                <ListGroup className="list-group-flush">
                  <Nav.Link
                    href="#"
                    className="text-center text-primary fw-bold border-bottom border-light py-3"
                  >
                    Notifications
                  </Nav.Link>

                  {notifications.map((n) => (
                    <Notification key={`notification-${n.id}`} {...n} />
                  ))}

                  <Dropdown.Item className="text-center text-primary fw-bold py-3">
                    View all
                  </Dropdown.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown> */}

            <Dropdown
              as={Nav.Item}
              className="ms-lg-3"
              onToggle={(isOpen) => setIsOpen(isOpen)}
            >
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div
                  className="media d-flex align-items-center px-1 dropdown-rounded"
                  style={isOpen ? { border: "1.5px solid #64748b" } : undefined}
                >
                  <Image src={Profile3} className="avatar rounded-circle" />
                  <div className="media-body ms-2 text-dark align-items-left justify-content-center d-none d-lg-flex flex-column">
                    <p
                      className="mb-0 fw-bold text-gray-900"
                      style={{ fontSize: "16px", lineHeight: "12px" }}
                    >
                      {JSON.parse(localStorage.getItem("TOKEN")).name}
                    </p>
                    <p
                      className="d-block fw-normal text-gray-500 mt-2 mb-0"
                      style={{ fontSize: "12px", lineHeight: "12px" }}
                    >
                      {userType === "enterprise"
                        ? "Enterprise"
                        : userType === "enterprise_user"
                        ? "Entp User"
                        : userType === "enterprise_reporting_user"
                        ? "Entp. Rep. User"
                        : userType === "customer relationship manager"
                        ? "CRM"
                        : userType === "super_admin"
                        ? "Super Admin"
                        : "Admin"}
                    </p>
                    {/* Reduced gap with custom style */}
                  </div>
                  {isOpen ? (
                    <IoIosArrowUp className="dropdown-icon mx-2" />
                  ) : (
                    <IoIosArrowDown className="dropdown-icon mx-2" />
                  )}
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="dashboard-dropdown dropdown-menu-end rounded-corners mt-2 p-2 w-auto">
                <Dropdown.Item className="d-flex align-items-center">
                  <UserCircleIcon className="dropdown-icon me-2" /> My User ID :{" "}
                  {userID}
                </Dropdown.Item>
                <Dropdown.Item className="d-flex align-items-center">
                  <CogIcon className="dropdown-icon me-2" /> Settings
                </Dropdown.Item>
                {userType === "enterprise" && (
                  <>
                    <Dropdown.Item
                      className="d-flex align-items-center"
                      onClick={handleShow}
                    >
                      <CogIcon className="dropdown-icon me-2" /> Whatsapp Number
                      Registration
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="d-flex align-items-center"
                      onClick={handleShowMigration}
                    >
                      <CogIcon className="dropdown-icon me-2" /> Whatsapp Number
                      Migration
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Item className="d-flex align-items-center">
                  <MdEmail className="dropdown-icon me-2" />{" "}
                  {JSON.parse(localStorage.getItem("TOKEN")).email}
                </Dropdown.Item>
                <Dropdown.Item className="d-flex align-items-center">
                  <SupportIcon className="dropdown-icon me-2" /> Support
                </Dropdown.Item>

                <Dropdown.Item
                  className="d-flex align-items-center"
                  onClick={Logout} // Call the Logout function on click
                >
                  <BiLogOutCircle className="dropdown-icon me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
      <WhatsappRegistrationModal show={showModal} handleClose={handleClose} />
      <WhatsappMigrationModal
        show={showModalMigration}
        handleClose={handleCloseMigration}
      />
    </Navbar>
  );
};
